<template>
    <div style="background-color: white;">
        <!-- {{ leraner_marksheet }} -->
        <br />
        <br />
        <div class="container"
            style="background-color: white; height: 1350px; border: 15px solid #623e7e; width: 1000px;">
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-col cols="12" sm="12" md="12" v-if="leraner_marksheet != ''">
                <!-- <center>
                    <v-row dense style="width: 500px; border: 1px solid black;">
                        <div class="col-2">
                            <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/WWS_Logo-01.png" width="80px" height="80px" alt="logo" />
                        </div>
                        <div class="col-6 pt-5">
                            <h2>
                                <span style="border-bottom-width: thin; border-bottom-style: outset;">
                                    Wisdom World School
                                </span>
                            </h2>
                            {{org_basic_data.address}}
                        </div>
                    </v-row>
                </center> -->
                <div class="row">
                    <div class="col-3"></div>
                    <div class="col-6 pt-8">
                        <div style="border: 1px solid #000;">
                            <div class="row">
                                <div class="col-2">
                                    <img class="pl-1"
                                        src="https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/WWS_Logo-01.png"
                                        width="80px" height="80px" alt="logo" />
                                </div>
                                <div class="col-10 pt-2" style="padding-left: 2rem;">
                                    <!-- <h2> -->
                                    <span
                                        style="border-bottom-width: thin; border-bottom-style: outset;font-weight:bolder; font-size: 35px;">
                                        Wisdom World School
                                    </span><br>
                                    <!-- </h2> -->
                                    <span style="font-size: 18px;"> {{ org_basic_data.address }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <center>
                    <span style="font-weight: bold; font-size: larger;line-height: 2;">
                        <strong>
                            <center> MARATHI LANGUAGE </center>
                        </strong>
                        <strong>
                            <center> REPORT CARD {{ ay }} </center>
                        </strong><br />
                    </span>
                </center>
                <br />
                <!-- <v-row   style="border: 3px solid black;line-height: 2;padding-left:40px"> -->
                <!-- <v-col cols="12" sm="12" md="12">
                        <v-row>
                            <strong class="pl-2 pr-2 pt-2"> STUDENT’S NAME -</strong>
                            <div class="pt-2" style="border-bottom: 2px solid rgb(120, 112, 206); border-bottom-style: outset;">{{name}}</div>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                            <strong class="pl-2 pr-2"> ROLL NO. </strong>
                            <span style="border-bottom: 2px solid rgb(120, 112, 206); border-bottom-style: outset;">{{roll_no}}</span>
                    </v-col>
                    <v-col style="text-align: right;" cols="12" sm="6" md="6">
                        <strong class="pl-2 pr-2">CLASS {{standard}} - DIV <span style="border-bottom: 2px solid rgb(120, 112, 206); border-bottom-style: outset;">{{ div }} </span></strong>
                    </v-col> -->
                <!-- </v-row> -->
                <v-row class="pl-7 pr-7" style="line-height: 2;">
                    <table style="width: 100%; ">
                        <tr style="border: none;">

                            <th class="pl-1" style="border: none;text-align: left;width:17%">
                                STUDENT’S NAME -
                            </th>
                            <th style="border: none;text-align: left" colspan="3">
                                <!-- <div class="pl-2" style="border-bottom: 2px solid rgb(120, 112, 206); border-bottom-style: outset;"> {{name}}</div> -->
                               <span v-if="name_as_on_aadhar_card!='' && name_as_on_aadhar_card!=null">{{ name_as_on_aadhar_card }}</span> <span v-else>{{ first_name }} {{ sur_name }}</span> 
                               <!-- {{ name }} -->
                                <hr
                                    style="background-color:rgb(120, 112, 206);color:rgb(120, 112, 206);width:45%;  border-style: solid;">

                            </th>
                        </tr>
                        <tr style="border: none;">
                            <th class="pl-1 pb-2" style="text-align: left;border: none;width:7%">
                                ROLL NO.
                                <!-- <span style="border-bottom: 1px solid rgb(120, 112, 206); border-bottom-style: outset;">{{roll_no}}</span> -->
                            </th>
                            <th class="pl-1 pb-2" style="text-align: left;border: none;">
                                {{ roll_no }}
                                <hr
                                    style="background-color:rgb(120, 112, 206);color:rgb(120, 112, 206);width:20%;  border-style: solid;">
                            </th>
                            <th class="pr-8 pb-1" style="text-align:right;border: none;">
                                CLASS {{ standard }}
                            </th>
                            <th style="text-align:left;border: none;">
                                <div class="row"> DIV -
                                    <div class="pl-1"> {{ div }}
                                        <hr
                                            style="background-color:rgb(120, 112, 206);color:rgb(120, 112, 206);width:190%;  border-style: solid;">
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </table>
                </v-row>

                <br />
                <br />
                <v-row class="pl-7 pr-7" style="line-height: 2;">
                    <table style="width: 100%;">
                        <tr>
                            <th style="width: 50%;">ASSESSMENTS</th>
                            <th>GRADE</th>
                        </tr>
                        <tr>
                            <!-- <th></th> -->
                            <th colspan="2">1<sup>st</sup> TERM</th>
                            <!-- <th>TEACHER’S COMMENT</th> -->
                        </tr>
                        <tr v-for="t1, i in leraner_marksheet[0].term_1_data" :key="i">
                            <td style="font-size: large; text-transform: uppercase;" class="pl-2">{{ t1.ass_name }}</td>
                            <td>
                                <center>{{ t1.grade }}</center>
                            </td>
                            <!-- <td>
                                <center>{{ t1.comment }}</center>
                            </td> -->
                        </tr>
                        <tr>
                            <!-- <th></th> -->
                            <th colspan="2">
                                2<sup>nd</sup> TERM
                            </th>
                        </tr>
                        <tr v-for="t1, i in leraner_marksheet[0].term_2_data" :key="i">
                            <td style="font-size: large; text-transform: uppercase;" class="pl-2">{{ t1.ass_name }}</td>
                            <td>
                                <center>{{ t1.grade }}</center>
                            </td>
                            <!-- <td>
                                <center>{{ t1.comment }}</center>
                            </td> -->
                        </tr>
                    </table>
                </v-row>
                <br />
                <!-- <v-row class="pl-7 pr-7">
                    <v-col cols="12" sm="12" md="12">
                        <strong>
                            GENERAL REMARK
                        </strong>
                        <div style="width: 100%; margin-left: 5px; margin-top: 15px;" class="stud_details1 row"></div>
                        <div style="width: 100%; margin-left: 5px; margin-top: 15px;" class="stud_details1 row"></div>
                    </v-col>
                </v-row> -->

                <div class="col-12" style="margin-top: -5px;" v-if="org_id == '1'">
                    <div class="row pl-2 pr-5" style="margin-top: -8px; margin-left: 0.1px; height: 35px;">
                        <div style="font-family: 'Times New Roman', Times, serif; line-height: 130%;width: 150%;">
                            <h3>General Remark: </h3> <br>
                            <div style="margin-left: 2px;font-size:17px;">
                                {{ general_remark }} 
                            </div>
                        </div>
                    </div>
                 </div>
<br><br>
                <v-row class="pl-5 pr-7">
                    <v-col cols="12" sm="12" md="12">
                        <strong>GRADE KEY</strong>
                    </v-col>
                    <!-- <v-col style="border: 1px solid black;" class="ml-5" cols="12" sm="4" md="4">
                        <v-row class="pl-5" dense v-for="g in grade_details" :key="g.id" v-if="g.gradename != '-'">
                            <strong>{{ g.gradename }} <span class="pl-4">-</span> </strong><span class="pl-4">{{
                                g.graderemark }}</span>
                        </v-row>
                    </v-col> -->
                    <v-col
                        style="border: 1px solid black; padding-left: 0; padding-right: 0; padding-top: 0; padding-bottom: 0;"
                        class="ml-5" cols="12" sm="4" md="4">
                        <v-row dense v-for="g in grade_details" :key="g.id" v-if="g.gradename !== '-'"
                            style="margin-bottom: 0; padding-bottom: 0;">
                            <v-col cols="3" class="text-left pl-4">
                                <strong>{{ g.gradename }}</strong>
                            </v-col>
                            <v-col cols="1" class="text-center pl-4">
                                <span v-if="g.gradename && g.graderemark">-</span>
                            </v-col>
                            <v-col cols="8" class="text-left pl-4">
                                <span>{{ g.graderemark }}</span>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="4" md="4"></v-col>
                    <v-col style="padding-top: 100px;" cols="12" sm="3" md="3">
                        <div style="width: 45%; margin-left: 5px;" class="stud_details2">
                            <strong>  
                                <img v-if="org_id=='1'"  src="https://eduplusschool.s3.ap-south-1.amazonaws.com/wws/principal_sign/wakad-removebg.png" width="100px" height="50px" alt="logo" /> 
                                <img v-else  src="https://eduplusschool.s3.ap-south-1.amazonaws.com/Role_link_icons/wws/2/chatgptimagesep22,2026,10_28_47amkz4i3o070g.png" width="100px" height="50px" alt="logo" /> 
                            </strong>
                        </div>
                        <strong>PRINCIPAL’S SIGNATURE</strong>
                        
                    </v-col>
                </v-row>
            </v-col>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    props: {
        org: Number,
    },
    data() {
        return {
            default_value: [],
            dialog_marks: false,
            overlay: false,
            selected: [],
            snackbar: false,
            search: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            asd: null,
            fetch_loader: false,
            show: false,
            course_list: [],
            stud_list: [],
            awspath: "",
            registration_no: null,
            standard: null,
            div: null,
            ay: null,
            name: null,
            sur_name: null,
            leraner_marksheet: [],
            colspan: null,
            overall_grade: null,
            remark: [],
            org_basic_data: [],
            assessment_type: null,
            grade_details: [],
            inst_name: null,
            org_id:null,
            general_remark:null,
            first_name:null,
            name_as_on_aadhar_card:null,
        };
    },

    methods: {
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        putnull3() {
            this.show = false;
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },

        getreport() { },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {
            const data = {
                lid: this.registration_no,
                ay: this.sel_ay_data,
                asd: this.asd,
                org: this.org,
            };
            axios
                .post("/WWSExamination/generateMarathiMarksheet", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.standard = res.data.standard;
                        this.div = res.data.div;
                        this.ay = res.data.ay;
                        this.name = res.data.name;
                        this.roll_no = res.data.roll_no;
                        this.photo = res.data.photo;
                        this.sur_name = res.data.sur_name;
                        this.first_name = res.data.first_name;
                        this.name_as_on_aadhar_card = res.data.name_as_on_aadhar_card
                        this.leraner_marksheet = res.data.leraner_marksheet;
                        this.org_basic_data = res.data.org_basic_data;
                        this.assessment_type = res.data.assessment_type;
                        this.grade_details = res.data.grade_details;
                        this.inst_name = res.data.inst_name;
                        this.general_remark = res.data.general_remark
                    }
                    if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.fmsg); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
    },
    mounted() {
        this.awspath = localStorage.getItem("awspath");
        this.sel_ay_data = localStorage.getItem("setay");
        this.asd = localStorage.getItem("setasd");
        this.registration_no = localStorage.getItem("setreg_no");
        this.org_id = localStorage.getItem("EPS-org-id")
        this.onload();
    },
};
</script>
<style scoped>
.avg {
    font-weight: 100px;
}

.stud_details1 {
    border-bottom: 1px solid rgb(120, 112, 206);
    font-family: "Times New Roman";
    height: 25px;
}

table,
th,
td {
    border: 2px solid black;
    border-collapse: collapse;
}

@media print {

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .card {
        border: none !important;
    }

    @page {
        size: A4;
        margin-top: none;
        padding-top: none;
        size: 13.5in 15.5in;

        /* size: 13in 18in; */
    }
}
</style>
